import React from "react";
import { Title, useMantineTheme } from "@mantine/core";

interface Heading6Props {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Heading6 - Styled H6 component
 * Usage: <Heading6>Tiny Title</Heading6>
 */
export const Heading6: React.FC<Heading6Props> = ({ children, className, style }) => {
  const theme = useMantineTheme();
  const other = theme.other as Record<string, string>;

  return (
    <Title
      order={6}
      className={className}
      style={{
        color: other.textPrimary,
        fontWeight: 600,
        ...style,
      }}
    >
      {children}
    </Title>
  );
};

export default Heading6;
